import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Box,
} from "@mui/material";
import "./styles.css";
import ShortRecording from "../../assets/short_recording.svg";

const AudioSizeShortError = ({
  isDialogOpen,
  warningHeading,
  warningMessage,
  onClickRecordAgain,
  t,
}) => {
  const handleCloseEventsForInvalidAudio = () => {
    onClickRecordAgain();
  };

  return (
    <Dialog
      className="audio-size-short-error"
      open={isDialogOpen}
      aria-labelledby="delete-audio-title"
    >
      <DialogTitle
        id="delte-audio-dialog-title"
        className="delete-audio-size-error-dialog-title"
      >
        <img src={ShortRecording} alt="Short" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="save-result-dialog-description"
          className="save-result-dialog-description"
        >
          <Typography className="warning-heading">{warningHeading}</Typography>
          <Typography className="warning-message">{warningMessage}</Typography>
          <Box className="button-container">
            <Button
              variant={"contained"}
              className="audio-short-size-retake-button"
              onClick={() => {
                handleCloseEventsForInvalidAudio();
              }}
              disableElevation
            >
              {t("retake")}
            </Button>
          </Box>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default AudioSizeShortError;
